import cookie from 'cookie'

const name = 'bearer'

export const removeBearerToken = () => {
  document.cookie = cookie.serialize(name, undefined, {
    maxAge: 0,
    path: `/student`,
  })
}

export const getBearerToken = () => {
  return cookie.parse(document.cookie)[name]
}
window.getBearerToken = getBearerToken

export const hasBearerToken = () => {
  return !!getBearerToken()
}
